export default __webpack_public_path__ + "static/media/toyota.72be60ce.webp";